import axios from "axios";
import { WEB_URL } from "../../constants";

export const VerifyOtpApi = async (body, ApiStatus) => {
    ApiStatus({ isLoader: true, isError: false, data: null });
    try {
        let res = await axios.post(WEB_URL + "verify_otp", body);
        ApiStatus({ isLoader: false, isError: false, data: res.data });
    } catch (err) {
        ApiStatus({ isLoader: false, isError: true, data: null });
    }
}